/**
 * Function de validatation du formulaire " bindingOfferForm "
 * @param  {Object} values   Valeurs du formulaire
 * @return {Object}          Object contenant toutes les erreurs
 */
const validate = values => {
  const errors = {
    unknowDeliveryOffer: []
  };
  if (values.unknowDeliveryOffer) {
    values.unknowDeliveryOffer.forEach((offer, index) => {
      if (!offer.bindingValue) {
        errors.unknowDeliveryOffer[index] = { bindingValue: 'Champs requis' };
      }
    });
  }
  return errors;
};

export default validate;
